import type { MouseEvent } from 'react';

import { SearchModal, SearchModalProvider, useSearchModal } from '@backstage/plugin-search';
import { Icon } from '@iconify/react';
import { SidebarNavItem } from '@ipen/components';

type Props = {
  className?: string;
  onNavigate?: () => void;
};

const SearchContent = ({
  className,
  onNavigate,
}: Props) => {
  const { state, toggleModal } = useSearchModal();

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    onNavigate?.();
    toggleModal();
  };

  return (
    <>
      <SidebarNavItem
        className={className}
        icon={<Icon icon="ri:search-line" />}
        label="Search"
        onClick={handleClick}
      />
      <SearchModal {...state} toggleModal={toggleModal} />
    </>
  );
};

export const BackstageSidebarSearchModal = (props: Props) => (
  <SearchModalProvider>
    <SearchContent {...props} />
  </SearchModalProvider>
);
